import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { ReportControllerService } from '@api/controller/reportController.service';
import { UserRoles } from '@auth/auth.model';
import { IStrumentiUtiliSettings } from '@model/strumenti-utili.model';
import { noop, tap } from 'rxjs';
import { createLinkForDownload } from '@shared/utils/utils';

const { ENTE, CPI } = UserRoles;
@Component({
  selector: 'app-strumenti-utili',
  templateUrl: './strumenti-utili.component.html',
  styleUrls: ['./strumenti-utili.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StrumentiUtiliComponent {
  constructor(private reportControllerService: ReportControllerService) {}

  @Input() settingsStrumentiUtili!: IStrumentiUtiliSettings;

  downloadFile(): void {
    const link = document.createElement('a');
    link.setAttribute('target', '_blank');
    switch (this.settingsStrumentiUtili.userRoles) {
      case CPI:
        this.reportControllerService
          .getReportListeClassi('response')
          .pipe(
            tap((response: HttpResponse<Blob>) => {
              const blob = response.body;
              if (blob) {
                const filenameMatch = /filename="(.*)"/.exec(
                  response.headers.get('content-disposition') ?? ''
                );
                createLinkForDownload(blob, filenameMatch?.[1] ?? '');
              }
            })
          )
          .subscribe(noop);
        break;
      case ENTE:
        link.setAttribute('href', 'assets/documents/template_avvio_corsi.zip');
        link.setAttribute('download', 'template_avvio_corsi.zip');
        break;
    }
    document.body.appendChild(link);
    link.click();
    link.remove();
  }
}
